"use client";

import * as React from "react";
import { useStore } from "@/lib/store";
import { HomeScreen } from "@/components/home-screen";
import { ReaderScreen } from "@/components/reader-screen";

export default function Home() {
  const screen = useStore((s) => s.screen);
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  // Avoid hydration mismatch — Zustand persist hydrates on the client
  if (!mounted) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Carregando ReadFluent...</div>
      </div>
    );
  }

  return screen === "home" ? <HomeScreen /> : <ReaderScreen />;
}
